module.exports = __webpack_public_path__ + "static/img/iosDownload.92be2c77.png";